"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useFetchAsJson3 = _interopRequireDefault(require("@eig-builder/core-utils/hooks/useFetchAsJson"));

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _businessSelectorContext = require("../context/business-selector-context");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var BusinessSelectorWrapper = function BusinessSelectorWrapper(_ref) {
  var children = _ref.children;

  var _useParams = (0, _reactRouterDom.useParams)(),
      siteId = _useParams.siteId,
      domainId = _useParams.domainId;

  var location = (0, _reactRouterDom.useLocation)();

  var _useFetchAsJson = (0, _useFetchAsJson3["default"])({}),
      _useFetchAsJson2 = (0, _slicedToArray2["default"])(_useFetchAsJson, 2),
      _useFetchAsJson2$ = _useFetchAsJson2[0],
      data = _useFetchAsJson2$.data,
      isLoading = _useFetchAsJson2$.isLoading,
      doFetch = _useFetchAsJson2[1];

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      logicLoading = _useState2[0],
      setLogicLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      currentBusiness = _useState4[0],
      setCurrentBusiness = _useState4[1];

  var _useState5 = (0, _react.useState)({
    sites: [],
    domains: []
  }),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      businesses = _useState6[0],
      setBusinesses = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      redirect = _useState8[0],
      setRedirect = _useState8[1];

  var prevLoc = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (prevLoc.current !== null && prevLoc.current === location.pathname) {
      prevLoc.current = location.pathname;
      return;
    }

    doFetch({
      url: (0, _urlHelper.api)('/v1.0/cp_home/selector')
    });
    prevLoc.current = location.pathname;
  }, [location]);
  (0, _react.useEffect)(function () {
    if (!isLoading && data) {
      setLogicLoading(true);
      var myBusinesses = {
        sites: data.sites.map(function (site) {
          return _objectSpread(_objectSpread({}, site), {}, {
            type: 'SITE'
          });
        }),
        domains: data.domains.map(function (domain) {
          return _objectSpread(_objectSpread({}, domain), {}, {
            type: 'DOMAIN'
          });
        })
      }; // if we are in /domain/:domainId or /site/:siteId
      // set the current business to the route

      if (siteId || domainId) {
        if (siteId) {
          var site = myBusinesses.sites.find(function (s) {
            return s.id === parseInt(siteId);
          });

          if (site) {
            setCurrentBusiness(site);
          } else {
            setRedirect(true);
          }
        } else if (domainId) {
          var domain = myBusinesses.domains.find(function (d) {
            return d.id === parseInt(domainId);
          });

          if (domain) {
            setCurrentBusiness(domain);
          } else {
            setRedirect(true);
          }
        }
      } else {
        var _myBusinesses$sites, _myBusinesses$domains;

        // otherwise, prefer site, then domain for default current business
        if ((_myBusinesses$sites = myBusinesses.sites) === null || _myBusinesses$sites === void 0 ? void 0 : _myBusinesses$sites.length) {
          setCurrentBusiness(myBusinesses.sites[0]);
        } else if ((_myBusinesses$domains = myBusinesses.domains) === null || _myBusinesses$domains === void 0 ? void 0 : _myBusinesses$domains.length) {
          setCurrentBusiness(myBusinesses.domains[0]);
        } else {
          setCurrentBusiness(null);
        }
      }

      setBusinesses(myBusinesses);
      setLogicLoading(false);
    }
  }, [data, domainId, siteId]);
  if (redirect) return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
    to: "/"
  });
  return /*#__PURE__*/_react["default"].createElement(_businessSelectorContext.BusinessSelectorContext.Provider, {
    value: {
      businesses: businesses,
      currentBusiness: currentBusiness,
      isLoading: isLoading || logicLoading,
      setCurrentBusiness: setCurrentBusiness
    }
  }, children);
};

BusinessSelectorWrapper.propTypes = {
  children: _propTypes["default"].any
};

var _default = (0, _react.memo)(BusinessSelectorWrapper);

exports["default"] = _default;